module.exports = __webpack_public_path__ + "static/img/icon-p3-3gs.35e8a018.png";